import { render, staticRenderFns } from "./CreditChinaDialog.vue?vue&type=template&id=4b064659&scoped=true&"
import script from "./CreditChinaDialog.vue?vue&type=script&lang=js&"
export * from "./CreditChinaDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreditChinaDialog.vue?vue&type=style&index=0&id=4b064659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b064659",
  null
  
)

export default component.exports